import { useMemo, useState } from "react";
import styles from "./Sales.module.css";
import { FiSearch, FiPlus, FiMoreVertical, FiCalendar, FiSettings } from "react-icons/fi";
import { BsThreeDotsVertical } from "react-icons/bs";

const mockRows = [
  { id: "286208171", employee: "Demo1", date: "19.01.2026, 14:24", payType: "Каспи", amount: 200, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286204375", employee: "Demo1", date: "19.01.2026, 14:05", payType: "Наличные", amount: 970, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286203976", employee: "Demo1", date: "19.01.2026, 14:03", payType: "Наличные", amount: 1670, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286203976", employee: "Demo1", date: "19.01.2026, 14:03", payType: "Наличные", amount: 1670, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286203976", employee: "Demo1", date: "19.01.2026, 14:03", payType: "Наличные", amount: 1670, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286203976", employee: "Demo1", date: "19.01.2026, 14:03", payType: "Наличные", amount: 1670, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286203976", employee: "Demo1", date: "19.01.2026, 14:03", payType: "Наличные", amount: 1670, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286177771", employee: "Demo1", date: "19.01.2026, 12:02", payType: "ПЕРЕЧИСЛЕНИЕ", amount: 3956.7, esf: "Нет", refund: "Отсутствует", fp: "" },
  { id: "286167419", employee: "Demo1", date: "19.01.2026, 11:13", payType: "Каспи", amount: 500, esf: "Нет", refund: "Присутствует", fp: "" },
  { id: "286164433", employee: "Demo1", date: "19.01.2026, 10:57", payType: "Каспи", amount: 1000000, esf: "Нет", refund: "Отсутствует", fp: "" },
];

const formatMoney = (n) =>
  new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);

const Badge = ({ value }) => {
  const isOk = value === "Присутствует";
  return (
    <span className={`${styles.badge} ${isOk ? styles.badgeRed : styles.badgeGray}`}>
      {value}
    </span>
  );
};

const Sales = () => {
  const [rows] = useState(mockRows);

  const [filters, setFilters] = useState({
    product: "",
    paymentType: "",
    date: "2026-01-19",
    fiscalNumber: "",
    docNumber: "",
    employee: "",
    sumFrom: "",
    sumTo: "",
    warehouse: "",
    esf: "",
    fiscalSign: "",
    refund: "",
    iin: "",
    discount: "",
    personType: "",
    source: "",
    category: "",
    client: "",
  });

  const [selected, setSelected] = useState({});

  const allChecked = useMemo(() => {
    const ids = rows.map((r) => r.id);
    if (!ids.length) return false;
    return ids.every((id) => selected[id]);
  }, [rows, selected]);

  const toggleAll = () => {
    if (allChecked) {
      setSelected({});
      return;
    }
    const next = {};
    rows.forEach((r) => (next[r.id] = true));
    setSelected(next);
  };

  const toggleOne = (id) => setSelected((p) => ({ ...p, [id]: !p[id] }));

  const stats = useMemo(() => {
    const total = rows.reduce((s, r) => s + r.amount, 0);
    const cash = rows.filter((r) => r.payType.toLowerCase().includes("нал")).reduce((s, r) => s + r.amount, 0);
    const nonCash = rows
      .filter((r) => r.payType.toLowerCase().includes("кас") || r.payType.toLowerCase().includes("карт"))
      .reduce((s, r) => s + r.amount, 0);
    const transfer = rows.filter((r) => r.payType.toLowerCase().includes("перечис")).reduce((s, r) => s + r.amount, 0);

    return { total, cash, nonCash, transfer, count: rows.length };
  }, [rows]);

  const setField = (key) => (e) => setFilters((p) => ({ ...p, [key]: e.target.value }));

  return (
    <div className={styles.wrapper}>
      {/* top right actions */}
      <div className={styles.topActions}>
        <button className={styles.searchBtn} type="button">
          <FiSearch size={16} />
          Поиск
        </button>

        <button className={styles.addBtn} type="button" title="Добавить">
          <FiPlus size={18} />
        </button>

        <button className={styles.moreBtn} type="button" title="Действия">
          <FiMoreVertical size={18} />
        </button>
      </div>

      {/* cards */}
      <div className={styles.cards}>
        <div className={styles.card}>
          <div className={styles.cardTitle}>Общая сумма</div>
          <div className={styles.cardValueBlue}>{formatMoney(stats.total)} ₸</div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardTitle}>Наличные</div>
          <div className={styles.cardValueGreen}>{formatMoney(stats.cash)} ₸</div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardTitle}>Безналичные</div>
          <div className={styles.cardValueOrange}>{formatMoney(stats.nonCash)} ₸</div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardTitle}>Перечисления</div>
          <div className={styles.cardValueBlack}>{formatMoney(stats.transfer)} ₸</div>
        </div>

        <div className={styles.card}>
          <div className={styles.cardTitle}>Количество продаж</div>
          <div className={styles.cardValueBlack}>{stats.count}</div>
        </div>
      </div>

      <div className={styles.filters}>
        <select className={styles.input} value={filters.product} onChange={setField("product")}>
          <option value="">Поиск товара</option>
          <option value="milk">Молоко</option>
          <option value="bread">Хлеб</option>
        </select>

        <select className={styles.input} value={filters.paymentType} onChange={setField("paymentType")}>
          <option value="">Тип оплаты</option>
          <option value="cash">Наличные</option>
          <option value="kaspi">Каспи</option>
          <option value="transfer">Перечисление</option>
        </select>

        <div className={styles.dateWrap}>
          <input className={styles.inputDate} type="date" value={filters.date} onChange={setField("date")} />
          <FiCalendar className={styles.dateIcon} size={18} />
        </div>

        <input className={styles.input} placeholder="Фискальный номер" value={filters.fiscalNumber} onChange={setField("fiscalNumber")} />
        <input className={styles.input} placeholder="Номер документа" value={filters.docNumber} onChange={setField("docNumber")} />

        <select className={styles.input} value={filters.employee} onChange={setField("employee")}>
          <option value="">Сотрудник</option>
          <option value="Demo1">Demo1</option>
        </select>

        <input className={styles.input} placeholder="Сумма от" value={filters.sumFrom} onChange={setField("sumFrom")} />
        <input className={styles.input} placeholder="Сумма до" value={filters.sumTo} onChange={setField("sumTo")} />

        <select className={styles.input} value={filters.warehouse} onChange={setField("warehouse")}>
          <option value="">Склад</option>
          <option value="main">Основной</option>
        </select>

        <select className={styles.input} value={filters.esf} onChange={setField("esf")}>
          <option value="">ЭСФ</option>
          <option value="yes">Да</option>
          <option value="no">Нет</option>
        </select>

        <select className={styles.input} value={filters.fiscalSign} onChange={setField("fiscalSign")}>
          <option value="">Фискальный признак</option>
          <option value="yes">Да</option>
          <option value="no">Нет</option>
        </select>

        <select className={styles.input} value={filters.refund} onChange={setField("refund")}>
          <option value="">Возврат</option>
          <option value="yes">Присутствует</option>
          <option value="no">Отсутствует</option>
        </select>

        <input className={styles.input} placeholder="ИИН/БИН" value={filters.iin} onChange={setField("iin")} />

        <select className={styles.input} value={filters.discount} onChange={setField("discount")}>
          <option value="">Скидка</option>
          <option value="yes">Есть</option>
          <option value="no">Нет</option>
        </select>

        <select className={styles.input} value={filters.personType} onChange={setField("personType")}>
          <option value="">Тип лица</option>
          <option value="fiz">Физ. лицо</option>
          <option value="yur">Юр. лицо</option>
        </select>

        <select className={styles.input} value={filters.source} onChange={setField("source")}>
          <option value="">Источник</option>
          <option value="pos">POS</option>
          <option value="web">WEB</option>
        </select>

        <select className={styles.input} value={filters.category} onChange={setField("category")}>
          <option value="">Поиск категории</option>
          <option value="food">Еда</option>
        </select>

        <select className={styles.input} value={filters.client} onChange={setField("client")}>
          <option value="">Клиент</option>
          <option value="client1">Client 1</option>
        </select>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
            <thead>
            <tr>
                <th className={styles.thCheck}>
                <input type="checkbox" checked={allChecked} onChange={toggleAll} />
                </th>
                <th className={styles.th}>№</th>
                <th className={styles.th}>Имя сотрудника</th>
                <th className={styles.th}>Дата</th>
                <th className={styles.th}>Способ оплаты</th>
                <th className={styles.th}>Сумма</th>
                <th className={styles.th}>ЭСФ</th>
                <th className={styles.th}>Возврат</th>
                <th className={styles.th}>Ф.П.</th>
                <th className={styles.thRight}>
                <button type="button" className={styles.iconBtn} title="Настройки">
                    <FiSettings size={16} />
                </button>
                </th>
            </tr>
            </thead>
        </table>

        <div className={styles.tableBody}>
            <table className={styles.table}>
            <tbody>
                {rows.map((r) => (
                <tr key={r.id} className={selected[r.id] ? styles.rowSelected : ""}>
                    <td className={styles.tdCheck}>
                    <input
                        type="checkbox"
                        checked={!!selected[r.id]}
                        onChange={() => toggleOne(r.id)}
                    />
                    </td>

                    <td className={styles.tdLink}>
                    <button type="button" className={styles.linkBtn}>
                        {r.id}
                    </button>
                    </td>

                    <td className={styles.td}>{r.employee}</td>
                    <td className={styles.td}>{r.date}</td>
                    <td className={styles.td}>{r.payType}</td>
                    <td className={styles.td}>{formatMoney(r.amount)} ₸</td>
                    <td className={styles.td}>{r.esf}</td>
                    <td className={styles.td}>
                    <Badge value={r.refund} />
                    </td>
                    <td className={styles.td}>{r.fp}</td>

                    <td className={styles.tdActions}>
                    <button type="button" className={styles.iconBtn} title="Действия">
                        <BsThreeDotsVertical size={16} />
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
    </div>

    </div>
  );
};

export default Sales;
